import { AxiosResponse } from "axios";
import { useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import { getApiData } from "views/utils/CallApi";
import { clearCart } from "views/utils/CartFunc";
import { Error } from "views/guest/pages/error/Error";
import { scrollTop, sendWindowHeight } from "views/utils/CommonFunc";
import { CtxOrder } from "views/utils/Contexts";

export function Complete(): JSX.Element{
    const [tel, setTel] = useState("");
    const [from, setFrom] = useState("");
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const [loadErr, setLoadErr] = useState("");
    const order = useContext(CtxOrder);
    const refWindow = useRef<HTMLDivElement>(null);

    //-------------------------------------
    //電話番号の設定とカート情報の削除
    //-------------------------------------
    useEffect(function () {

        scrollTop();

        //カート画面を経由していない（ゲスト用セッションがない）場合、エラー
        if (!window.sessionStorage.getItem("guest_access_token")){
            setLoadErr("token_error");
            return;
        }
        //注文フォーム情報が使用開始していない場合（リロードされた場合）、エラー
        if (order.data.initial){
            setLoadErr("reload_error");
            return;
        }
        //トークンを削除（前画面に戻れないようにする）
        sessionStorage.removeItem('guest_access_exp');
        sessionStorage.removeItem('guest_access_token');

        getApiData(`/cart/company_info`,
            {},
            function (res: AxiosResponse<any>) {  
                switch (res.status) {
                    case 200:
                        setTel(res.data.tel);
                        setFrom(res.data.from);
                        break;
                    default:
                        setTel("代表");
                        setFrom("代表");
                }
                //カート情報を削除
                clearCart();
            }
        );

        //ウィンドウサイズを呼び出し元に渡す
        sendWindowHeight(refWindow);

    }, []);
    
    //画面リサイズでウィンドウサイズを呼び出し元に渡す
    useLayoutEffect(function(){
        window.addEventListener('resize', resize);
        return () => window.removeEventListener('resize', resize);
    });
    function resize(){
        sendWindowHeight(refWindow);
    }

    if (loadErr){
        return (
            <Error type={loadErr}/>
        )
    } else {
        return (
            <div className="order-main" ref={refWindow}>
                <div className="order-width-max">
                    <div className="order-box">
                        <div className="order-flow">
                            <ul className="order-flow-list">
                                <li className="is-past">見積内容の確認</li>
                                <li className="is-past">希望日時の選択</li>
                                <li className="is-past">申込情報の入力</li>
                                <li className="is-past">申込内容の確認</li>
                                <li className="is-current">申込完了</li>
                            </ul>
                        </div>
                        <div className="order-form">
                            <div className="order-form-title">
                                お申込完了
                            </div>
                            <div className="margin-t-20 msgbox info">
                                <p className="text-size-l text-weight-bold text-center">お申込番号：{params.get('orderNo')}</p>
                                <p className="margin-t-10">サービスのお申込が完了しました。お申込いただきました内容はメールにてお送りしております。<br/>
                                お申込内容の実施日時が確定しましたら、メール又はお電話にて折り返しこちらからご連絡させていただきます。<br/><br/>
                                お申込み完了メールが届かない場合は、迷惑メールフォルダに振り分けられている場合があります。<br/>
                                または、お使いのメールソフトやスマートフォンの受信設定によっては受け取れない可能性があります。<br/>
                                メール送信元「{from}」のメールアドレス及びドメインからのメールを受信できるように設定してください。<br/>
                                メールが届かない場合は、お手数ですが、{tel} までご連絡ください。</p>
                            </div>
                        </div>
                    </div>
                    <div className="form-row control-horizon control-center">
                        <button className="btn-order btn-secondary btn-icon-left" onClick={function(){window.location.href=process.env.REACT_APP_HOMEPAGEURL+""}}><span className="icon material-icons-round md-18">home</span>トップへ戻る</button>
                    </div>
                </div>
            </div>
        )
    }
}